import React, { useEffect, useState } from 'react'
import Home from "./Components/home/Home"
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Projects from './Components/project/Projects'
import About from './Components/aboutme/About'
import Loader from './Components/Loader'

const App = () => {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      // Simulate loading data or performing async operations
      await new Promise((resolve) => setTimeout(resolve, 1300)); // Simulated loading time
      setLoading(0);
    };

    loadData();
  }, []);
  return (
    <div className='bgc' style={{backgroundColor:"rgb(68,2,2)"}}>

      {loading?<Loader />: 
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home />}></Route>
          <Route path='/projects' element={<Projects />}></Route>
          <Route path='/aboutme' element={<About />}></Route>

        </Routes>


      </BrowserRouter>
      }
      
    </div>
  )
}

export default App